export default "__VITE_ASSET__9X4T5rjD__"